<template>
  <span>
    
    <span v-if="!showMultiple">
      <b-button class="inlineBtn" variant="dark" @click="showSefosMessage = true" v-if="sefosEnabled">
        {{ $t("MESSAGES.COMPOSE") }}
      </b-button>
      <b-button class="inlineBtn" variant="dark" @click="showSdkMessage = true" v-if="sdkVisible">
        {{ $t("MESSAGES.COMPOSE") }}
      </b-button>
      <b-button class="inlineBtn" variant="dark" @click="showFaxMessage = true" v-if="faxVisible">
        {{ $t("MESSAGES.COMPOSE") }}
      </b-button>
    </span>
    <span v-if="showMultiple">
      <b-dropdown variant="dark">
          <template #button-content>{{ $t("MESSAGES.COMPOSE") }}</template>
           <b-dropdown-item href="#" @click="showSefos" v-if="sefosEnabled"><img class="icon mr-2" src="/img/message_type/message.png" /> {{ $t("MESSAGES.TYPE.message") }}</b-dropdown-item>
          <b-dropdown-item v-if="checkValidVersion('4.2.0') && sdkVisible" href="#" @click="showSDK"><img class="icon mr-2" src="/img/message_type/sdk-message.png?id=2" /> {{ $t("MESSAGES.TYPE.sdk-message") }}</b-dropdown-item>
          <b-dropdown-item v-if="faxVisible" href="#" @click="showFax"><img class="icon mr-2" src="/img/message_type/fax-message.png" /> {{ $t("MESSAGES.TYPE.fax-message") }}</b-dropdown-item>
        </b-dropdown>
    </span>
        
    <AddSefosMessage v-if="checkValidVersion('4.3.0') && sefosEnabled" :show="showSefosMessage" :user_uuid="user_uuid" @changeShow="changeShowSefosMessage" @sentMessage="sentMessage" :functionbox_uuid="functionbox_uuid"></AddSefosMessage>
    <AddSefosMessage_4_2 v-if="checkValidVersion('4.2.0') && !checkValidVersion('4.3.0') && sefosEnabled" :show="showSefosMessage" :user_uuid="user_uuid" @changeShow="changeShowSefosMessage" @sentMessage="sentMessage" :functionbox_uuid="functionbox_uuid"></AddSefosMessage_4_2>
    <AddSefosMessage_4_1 v-if="!checkValidVersion('4.3.0') && !checkValidVersion('4.2.0') && sefosEnabled" :show="showSefosMessage" :user_uuid="user_uuid" @changeShow="changeShowSefosMessage" @sentMessage="sentMessage" :functionbox_uuid="functionbox_uuid"></AddSefosMessage_4_1>

    <AddFaxMessage v-if="checkValidVersion('4.3.0') && faxVisible" :show="showFaxMessage"  @changeShow="changeShowFaxMessage" @sentMessage="sentMessage" :functionbox_uuid="functionbox_uuid"></AddFaxMessage>
    <AddFaxMessage_4_2 v-if="!checkValidVersion('4.3.0') && faxVisible" :show="showFaxMessage"  @changeShow="changeShowFaxMessage" @sentMessage="sentMessage" :functionbox_uuid="functionbox_uuid"></AddFaxMessage_4_2>

    <AddSDKMessage v-if="checkValidVersion('4.3.0') && sdkVisible" :show="showSdkMessage"  @changeShow="changeShowSdkMessage" @sentMessage="sentMessage" :functionbox_uuid="functionbox_uuid"></AddSDKMessage>    
    <AddSDKMessage_4_2 v-if="checkValidVersion('4.2.0') && !checkValidVersion('4.3.0') && sdkVisible" :show="showSdkMessage"  @changeShow="changeShowSdkMessage" @sentMessage="sentMessage" :functionbox_uuid="functionbox_uuid"></AddSDKMessage_4_2>    

    
  </span>
</template>
<script>
import AddSefosMessage_4_1 from "@/components/Compose/Message/SefosMessage_4_1";
import AddSefosMessage_4_2 from "@/components/Compose/Message/SefosMessage_4_2";
import AddSefosMessage from "@/components/Compose/Message/SefosMessage";
import AddSDKMessage from "@/components/Compose/Message/SDKMessage";
import AddSDKMessage_4_2 from "@/components/Compose/Message/SDKMessage_4_2";
import AddFaxMessage from "@/components/Compose/Message/FaxMessage";
import AddFaxMessage_4_2 from "@/components/Compose/Message/FaxMessage_4_2";
export default {
  props: ["functionbox_uuid","user_uuid"],
  components: {
    AddSefosMessage,
    AddSDKMessage,
    AddSDKMessage_4_2,
    AddSefosMessage_4_1,
    AddSefosMessage_4_2,
    AddFaxMessage,
    AddFaxMessage_4_2
  },
  data() {
    return {
      showSefosMessage: false,
      showSdkMessage: false,
      showFaxMessage: false,
      sefosEnabled: true
    };
  },
  methods: {
    async init(){
      this.checkSefosEnabled();
    },
    async checkSefosEnabled(){     
      if(this.checkValidVersion('4.3.0'))
      {
        let self = this; 
        await this.$http
          .post(this.user.hostname + "/sefos-message/enabled",{
            organisation_uuid: this.user.information.organisation.organisation_uuid,
            functionbox_uuid: ""
          })
          .then(function(result) {
            self.sefosEnabled = result.data;
          })
          .catch(function() {
            self.sefosEnabled = false;
          });
      }
    },
    changeShowSefosMessage(val){
      this.showSefosMessage = val;
    },
    changeShowSdkMessage(val){
      this.showSdkMessage = val;
    },
    changeShowFaxMessage(val){
      this.showFaxMessage = val;
    },
    showSefos(){
      this.showSefosMessage = true;
    },
    showFax(){
      this.showFaxMessage = true;
    },
    showSDK(){
      this.showSdkMessage = true;
    },
    sentMessage() {
      this.showSefosMessage = false;
      this.showSdkMessage = false;
      this.showFaxMessage = false;
      this.$emit("sentMessage");
    }
  },
  computed: {
    showMultiple() {
      if (this.functionbox_uuid == "") {
        return false;
      } else {
        if(this.sdkVisible == true && this.faxVisible == true)
        {
          return true;
        }
        if(this.sdkVisible == true && this.sefosEnabled == true)
        {
          return true;
        }
        if(this.faxVisible == true && this.sefosEnabled == true)
        {
          return true;
        }
        return false;
      }
    },
    composeText() {
      return this.$t('MESSAGES.COMPOSE') + " - SEFOS";
    },
    faxVisible(){
      if(this.functionbox_uuid != "")
      {
        let self = this;
        let fb = this.user.functionboxes.items.filter(function(item) {
          return item.functionbox_uuid == self.functionbox_uuid
        });
        if(fb.length == 0)
        {
          return false;
        }else{
          if(fb[0].fax_enabled != undefined)
          {
            return fb[0].fax_enabled;
          }
        }
      }
      return false;
    },
    sdkVisible(){
      if(this.checkValidVersion('4.2.0'))
      {
        if (this.user.ticket.sdk_enabled) {
          if (this.functionbox_uuid != "") {
            let self = this;
            let fb = this.user.functionboxes.items.filter(function (item) {
              return item.functionbox_uuid == self.functionbox_uuid;
            });
            if (fb.length == 0) {
              return false;
            } else {
              if (fb[0].sdk_enabled != undefined) {
                return fb[0].sdk_enabled;
              }
            }
          }
        } 
      }
      return false;
    }
  },
  mounted() {
    this.init();
  },
};
</script>
